define('LoyaltyMyAccount.Birthdate.PomoCode.View', [
    'loyalty_myaccount_birthdate_promo_code.tpl',
    'Backbone',
    'SC.Configuration',
    'Profile.Model',
    'underscore'
], function LoyaltyMyAccountBirthdatePomoCodeView(
    loyaltyMyaccountBirthdateformTpl,
    Backbone,
    Configuration,
    ProfileModel,
    _
) {
    'use strict';

    return Backbone.View.extend({
        template: loyaltyMyaccountBirthdateformTpl,
        initialize: function initialize() {
            var today = window.moment();
            var showDaysBefore = this.options.application.getComponent('Environment').getConfig('LoyaltyMyaccount.BirthdatePomoCode.showDaysBefore', 5);
            var showDaysAfter = this.options.application.getComponent('Environment').getConfig('LoyaltyMyaccount.BirthdatePomoCode.showDaysAfter', 5);
            var showSince;
            var showUntil;
            var birthdate;
            var customerBirthdateField;
            this.show = false;

            this.profile = ProfileModel.getInstance();
            customerBirthdateField = _.findWhere(this.profile.get('customfields'), { name: 'custentitycustomentityaws_birth_date' });
            if (customerBirthdateField && customerBirthdateField.value && _.isNumber(showDaysBefore) && _.isNumber(showDaysAfter)) {
                birthdate = window.moment(customerBirthdateField.value);
                birthdate = birthdate.set('year', today.get('year'));
                showSince = birthdate.clone().subtract(showDaysBefore, 'days', '[]');
                showUntil = birthdate.clone().add(showDaysAfter, 'days');
                this.show = today.isBetween(showSince, showUntil, 'day');
            }
        },
        getContext: function getContext() {
            return {
                show: this.show,
                message: Configuration.get('LoyaltyMyaccount.BirthdatePomoCode.message')
            };
        }
    });
});
